<template>
	<div
		v-if="items.results.length > 0"
		class="card"
	>
		<div class="card-header py-3 pr-3 bold text-uppercase text-dark d-flex align-items-center">
			<a-badge
				:count="items.total"
				:overflow-count="99"
				:offset="[15,0]"
			>
				<fa-icon
					icon="receipt"
					class="mr-2"
				/>  Presupuestos
			</a-badge>

			<div class="ml-auto" />

			<a-tooltip placement="top">
				<template slot="title">
					<fa-icon
						:icon="['fas', 'external-link-alt']"
						class="mr-2"
					/> Ver más
				</template>
				<a-button
					v-if="haveMore"
					class="mr-2"
					@click="$router.push({name: 'facturas', query: {empresa: id}})"
				>
					<fa-icon :icon="['fas', 'external-link-alt']" />
				</a-button>
			</a-tooltip>

			<a-tooltip placement="top">
				<template slot="title">
					<fa-icon
						:icon="['fas', 'sync-alt']"
						class="mr-2"
					/> Refrescar
				</template>
				<a-button @click="list">
					<fa-icon
						:icon="['fas', 'sync-alt']"
						:spin="loading"
					/>
				</a-button>
			</a-tooltip>
		</div>

		<div class="card-body px-0 py-2">
			<table class="table table-stripped mb-0">
				<tbody>
					<tr
						v-for="(item,index) in items.results"
						:key="index"
					>
						<td :class="$style.icon">
							<a-tooltip placement="left">
								<template
									v-if="!item.PresupuestoPDF"
									slot="title"
								>
									No se ha generado el PDF
								</template>
								<img
									:class="item.PresupuestoPDF ? 'pointer': 'img-gray'"
									src="@/application/assets/images/icons/budget.svg"
									@click="openPDF(item)"
								>
							</a-tooltip>
						</td>
						<td :class="$style.info">
							<div
								:class="item.PresupuestoPDF ? 'pointer' : 'nodrop'"
								@click="openPDF(item)"
							>
								<h5>{{ item.PresupuestoTotal | price }}€</h5>
								<span>
									<fa-icon
										:icon="['fas', 'qrcode']"
									/> {{ item._EntityId }}
								</span>
							</div>
						</td>
						<td :class="$style.email">
							<g-email
								:value="item"
								size="small"
							/>
						</td>
						<td :class="$style.status">
							<a-tooltip
								placement="top"
							>
								<template slot="title">
									{{ $gestios.$utils.getValue(
										'presupuestos',
										'PresupuestoEstado',
										item.PresupuestoEstado
									) }}
								</template>

								<fa-icon
									v-if="item.PresupuestoEstado===0"
									:icon="['far', 'clock']"
									class="mr-2 text-warning"
								/>
								<fa-icon
									v-else-if="item.PresupuestoEstado===1"
									:icon="['far', 'check-circle']"
									class="mr-2 text-success"
								/>
								<fa-icon
									v-else-if="item.PresupuestoEstado===2"
									:icon="['far', 'sad-tear']"
									class="mr-2 text-danger"
								/>
							</a-tooltip>
						</td>
						<td :class="$style.actions">
							<g-item-actions
								app="presupuestos"
								:item="item"
								:text="false"
								:loading="working === item._EntityId"
								mode="dropdown"
								@edit="$router.push({name: 'presupuestos_edit', params: {id: $event._EntityId}})"
							>
								<template slot="top">
									<!-- Cambiar estado -->
									<a-menu-item
										key="5"
										:class="item.PresupuestoEstado === 0 ? 'text-muted': 'text-warning'"
										@click="setStatus(item._EntityId, 0, 'pendiente')"
									>
										<fa-icon
											:icon="['far','clock']"
											class="mr-2"
										/> Pendiente
									</a-menu-item>

									<!-- Cambiar estado -->
									<a-menu-item
										key="4"
										:class="item.PresupuestoEstado === 1 ? 'text-muted': 'text-success'"
										@click="setStatus(item._EntityId, 1, 'aprobado')"
									>
										<fa-icon
											:icon="['fas','check']"
											class="mr-2"
										/> Aprobado
									</a-menu-item>

									<!-- Cambiar estado -->
									<a-menu-item
										key="3"
										:class="item.PresupuestoEstado === 2 ? 'text-muted': 'text-danger'"
										@click="setStatus(item._EntityId, 2, 'rechazado')"
									>
										<fa-icon
											:icon="['far','sad-tear']"
											class="mr-2"
										/> Rechazado
									</a-menu-item>

									<a-menu-divider />

									<!-- Enviar email -->
									<a-menu-item
										v-if="item.PresupuestoPDF"
										key="2"
										:disabled="working === item._EntityId"
										@click="mailerScope = item"
									>
										<fa-icon
											:icon="['far','paper-plane']"
											class="mr-2"
										/> Enviar email
									</a-menu-item>

									<!-- Crear PDF -->
									<a-menu-item
										key="1"
										:disabled="working === item._EntityId"
									>
										<a-popconfirm
											v-if="$gestios.items('presupuestos').auth({
												scopes: [`set.mine`, `set`],
												strict: false,
												item
											})"
											title="¿Se regenerará el PDF del presupuesto. ¿Estas seguro?"
											@confirm="() => createPDF(item)"
										>
											<fa-icon
												:icon="['fas','file-pdf']"
												class="mr-2"
											/>
											Generar PDF
										</a-popconfirm>
									</a-menu-item>
								</template>
							</g-item-actions>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<mailer
			:item="mailerScope"
			view="presupuestosList"
			@close="mailerScope = null"
		/>
	</div>
</template>

<script>
import mailer from '@/application/views/presupuestos/mailer';
import presupuestosMX from '@/application/helpers/presupuestos';

export default {
	name: 'BudgetList',
	components: { mailer },
	props: {
		id: {
			type: Number,
			default: 0
		},
		limit: {
			type: Number,
			default: 5
		}
	},
	data() {
		return {
			loading: false,
			working: false,
			mailerScope: null,
			e404: false
		};
	},
	computed: {
		view() {
			return `presupuestos_${this.id}`;
		},
		items() {
			const results = this.$gestios.$cache.view(this.view);
			if (results) return results;
			return {
				results: [],
				total: 0
			};
		},
		haveMore() {
			if (this.items.total > this.limit) return true;
			return false;
		}
	},
	watch: {
		id() {
			this.list();
		}
	},
	created() {
		this.list();
	},
	methods: {
		async list() {
			this.loading = true;

			let filters = null;
			if (this.id > 0) {
				filters = [{
					_ParentOperator: 'AND',
					_Operator: 'AND',
					Fields: {
						Empresa: {
							type: 'number',
							lig: '=',
							value: this.id
						}
					}
				}];
			}

			const result = await this.$gestios.items('presupuestos').list({
				view: this.view,
				page: 1,
				limit: this.limit,
				order: {
					PresupuestoFecha: 'desc'
				},
				filters,
				reset: true
			});

			if (!result.ok) {
				this.e404 = true;
			}

			this.loading = false;
		},
		async setStatus(id, value, text) {
			this.working = id;
			await presupuestosMX.setStatus(id, value, text);
			this.working = null;
		},
		async createPDF(item) {
			this.working = item._EntityId;
			await presupuestosMX.renderPDF(item);
			this.working = null;
		},
		openPDF(item) {
			if (item.PresupuestoPDF) {
				window.open(item.PresupuestoPDF.Link, '_blank');
			}
		}
	}
};
</script>

<style lang="scss" module>
	.info, .actions, .icon, .status, .email{
		vertical-align: middle !important;
	}

	.icon{
		width: 40px;

		img{
			width: 40px;
		}
	}

	.info{
		display: flex;
		align-items: center;

		span{
			color: $gray-5;
			font-size: 12px;

			svg{
				font-size: 12px;
			}
		}

		h5{
			margin-top:3px;
			font-size: 16px;
			line-height: 16px;
			margin: 0;
		}
	}

	.email{
		text-align: right;
		padding-right: 0 !important;
	}

	.actions{
		width: 60px;
		text-align: right;
		padding-left: 0 !important;
	}

	.status{
		width: auto;
		text-align: right;
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
</style>
